<template>
  <tabs>
    <tab title="Recent Users">
      <UsersList />
    </tab>
    <tab title="Expired Users" v-if="hasScramblePermission">
      <ExpiredInactiveUsersExport />

      <h1 class="light">Data Privacy</h1>
      <UserScramblePage />
    </tab>
  </tabs>
</template>

<script>
import { Tabs, Tab } from 'uiv'
import UsersList from './UsersList'
import UserScramblePage from './UserScramblePage'
import ExpiredInactiveUsersExport from './ExpiredInactiveUsersExport'
import { Permissions } from '../client_auth/permissions'

export default {
  name: 'TabbedUsersPage',
  components: {
    Tabs,
    Tab,
    UsersList,
    UserScramblePage,
    ExpiredInactiveUsersExport
  },
  data() {
    return {
      hasScramblePermission: false
    };
  },
  created() {
    this.$angularWorld.auth.doesUserHavePermission([Permissions.ScrambleOps])
      .then(hasPermission => {
        this.hasScramblePermission = hasPermission;
      });
  }
}
</script>

<style lang="less" scoped>
</style>
